import { createFileRoute } from '@tanstack/react-router'
import { AssistantMarkdown } from '@/features/assistant/components/assistant-markdown'

export const Route = createFileRoute('/(public)/dev/chat-preview')({
  component: ChatPreview,
})

const SAMPLE = `Here's how your organisation is doing today:

**Shifts Today**: 1 (Unassigned: 1)

| Metric | Count |
| --- | --- |
| Clients with Low Funds | 4 |
| Onboarding in Progress | 3 |
| Open Incidents | 25 |

A quick look at open incidents by status:

\`\`\`chart
{ "type": "bar", "title": "Open incidents by status", "x": "label", "data": [ { "label": "New", "value": 12 }, { "label": "In Review", "value": 8 }, { "label": "Escalated", "value": 5 } ] }
\`\`\`

And how shifts have trended this week:

\`\`\`chart
{ "type": "line", "title": "Shifts per day", "x": "day", "series": ["filled","unfilled"], "data": [ { "day": "Mon", "filled": 8, "unfilled": 2 }, { "day": "Tue", "filled": 10, "unfilled": 1 }, { "day": "Wed", "filled": 7, "unfilled": 3 }, { "day": "Thu", "filled": 11, "unfilled": 0 }, { "day": "Fri", "filled": 9, "unfilled": 2 } ] }
\`\`\`

Funding mix across participants:

\`\`\`chart
{ "type": "pie", "x": "label", "data": [ { "label": "Self-managed", "value": 18 }, { "label": "Plan-managed", "value": 24 }, { "label": "NDIA-managed", "value": 9 } ] }
\`\`\`

Let me know if you'd like a breakdown by support type!`

/**
 * Dev-only preview of how the assistant renders markdown tables + inline charts.
 * Not part of the product (renders nothing outside `vite dev`).
 */
function ChatPreview() {
  if (!import.meta.env.DEV) return null
  return (
    <div className="flex min-h-screen justify-center bg-neutral-100 p-10">
      <div
        className="bg-muted h-fit w-[380px] rounded-lg px-3 py-2 text-sm"
        data-testid="md-stage"
      >
        <AssistantMarkdown content={SAMPLE} />
      </div>
    </div>
  )
}
